"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "pub-container home"
  }, [_c("div", {
    staticClass: "home-title-box"
  }, [_vm._v(" 四大服务项目 一站式解决 ")]), _c("div", {
    staticClass: "mian-box"
  }, _vm._l(_vm.mainItem, function (item) {
    return _c("div", {
      key: item.title,
      staticClass: "main-item-box",
      on: {
        click: function click($event) {
          return _vm.gotoPage(item);
        }
      }
    }, [_c("div", {
      staticClass: "item-left",
      style: {
        background: item.color
      }
    }, [_c("img", {
      attrs: {
        src: item.image,
        alt: ""
      }
    })]), _c("div", {
      staticClass: "item-right"
    }, [_c("div", {
      staticClass: "item-right-top"
    }, [_vm._v(_vm._s(item.title))]), _c("div", {
      staticClass: "item-right-bottom"
    }, [_vm._v(_vm._s(item.desc))])])]);
  }), 0)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;